import _ from 'lodash';

import { FEE_TYPE_OVERRIDABLE_FIELDS } from 'constants/feeTypes';

export const getMergedFeeTypeWithOverride = (existingFeeType, overridePayload) => {
  const mergedOverrideFields = FEE_TYPE_OVERRIDABLE_FIELDS.reduce((acc, fieldKey) => {
    const overrideValue = overridePayload?.[fieldKey];

    if (_.isNil(overrideValue)) {
      return acc;
    }

    acc[fieldKey] = overrideValue;

    return acc;
  }, {});

  return {
    ...existingFeeType,
    ...mergedOverrideFields,
    hasLocalOverride: true,
    localOverride: overridePayload,
  };
};
